import { Button } from '@cobliteam/ui/components';
import { favoriteButton } from './styles';

import type { UUID } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';

import { useUpdateFavoriteMedia } from '@cobliteam/hooks/src/useCamera/useCameraMedia';

import Icon from '@cobliteam/ui/icons';

import Alert from '@cobliteam/ui/components/Alert';

import { MediaTableType } from '../../utils';

interface MediaFavoriteButtonProps {
  isFavoriteCurrentState?: boolean;
  mediaId: UUID;
  id?: string;
  origin?: string;
  color?: 'default' | 'primary';
}

const MediaFavoriteButton = ({ isFavoriteCurrentState, mediaId, id, origin, color = 'primary' }: MediaFavoriteButtonProps) => {
  const isEvent = window.location.pathname.includes('event');
  const { mutateAsync } = useUpdateFavoriteMedia(isEvent ? MediaTableType.EVENT_MEDIA : MediaTableType.FOOTAGE_MEDIA);

  const handleFavoriteButtonClick = () => {
    Analytics.track('Favorite Media Button Clicked', {
      newFavoriteStatus: !isFavoriteCurrentState,
      page: window.location.pathname,
      origin,
    });

    const data = {
      mediaId,
      isFavorite: !isFavoriteCurrentState,
    };

    try {
      mutateAsync({ updateUserFavoriteMedia: data });
      Alert.success(`Vídeo ${isFavoriteCurrentState ? 'desfavoritado ' : 'favoritado'} com sucesso!`);
    } catch (error) {
      Alert.error(`Ops! Houve um problema ao ${isFavoriteCurrentState ? 'desfavoritar ' : 'favoritar'} o vídeo. Tente novamente.`);
    }
  };

  const getFavoriteButtonIcon = () => {
    return <Icon name={isFavoriteCurrentState ? 'star-off' : 'star'} size='sm' />;
  };

  return (
    <Button
      startIcon={getFavoriteButtonIcon()}
      size='sm'
      color={color}
      variant='outlined'
      onClick={handleFavoriteButtonClick}
      id={id}
      className={favoriteButton(origin === 'media-table')}
    >
      {isFavoriteCurrentState ? 'Desfavoritar' : 'Favoritar'}
    </Button>
  );
};
export default MediaFavoriteButton;
